import { createRouter, createWebHistory } from 'vue-router'
import { ROUTE_NAMES } from '@/router/router-names'
import { ROUTE_DEFINITIONS } from '@/router/router-definition'

const routes = [
	ROUTE_DEFINITIONS.PAGE_DASHBOARD,
	ROUTE_DEFINITIONS.PAGE_USERS,
	ROUTE_DEFINITIONS.GAMES_PAGE,
	ROUTE_DEFINITIONS.PAGE_PAYMENT_SYSTEMS,
	ROUTE_DEFINITIONS.PAGE_PAYMENTS,
	ROUTE_DEFINITIONS.PAGE_REFERRAL,
	ROUTE_DEFINITIONS.PAGE_PARTNERS_PROGRAM,
	ROUTE_DEFINITIONS.PAGE_CMS,
	ROUTE_DEFINITIONS.PAGE_CHAT,
	ROUTE_DEFINITIONS.PAGE_BONUS,
	ROUTE_DEFINITIONS.PAGE_MISSIONS,
	ROUTE_DEFINITIONS.PAGE_TRANSLATIONS,
	ROUTE_DEFINITIONS.PAGE_CATALOG,
]

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes,
	scrollBehavior(to) {
		return to.hash ? { el: to.hash } : { top: 0 }
	},
})

router.beforeEach(async (to, from, next) => {
	const role = localStorage.getItem('role')
	const routeExists = to?.name
	const roleAllowed = to?.meta.role?.find(el => el === role)

	if (routeExists && roleAllowed) {
		return next()
	} else {
		if (role !== null) {
			return next({ name: ROUTE_NAMES.PAGE_DASHBOARD.routeName })
		} else {
			return next() // todo переписать роуты, добавить маршрут под логин
		}
	}
})

router.onError(error => {
	if (error.message.includes('Failed to fetch dynamically imported module')) {
		// window.location = '/'
	}
})

export default router
